import React from 'react';
import { XIcon } from 'lucide-react';
import { Toggle } from '../common/Toggle';
export const BackofficeModal = ({
  isOpen,
  onClose,
  user
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-60">
      <div className="bg-white rounded-lg w-full max-w-2xl mx-4" data-id="element-61">
        <div className="flex justify-between items-center p-6 border-b" data-id="element-62">
          <h2 className="text-xl font-semibold" data-id="element-63">
            {user ? 'Editar Usuario' : 'Crear Nuevo Usuario'}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-64">
            <XIcon className="h-6 w-6" data-id="element-65" />
          </button>
        </div>
        <div className="p-6" data-id="element-66">
          <div className="space-y-6" data-id="element-67">
            <div className="grid grid-cols-2 gap-4" data-id="element-68">
              <div data-id="element-69">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-70">
                  Tipo de Identificación
                </label>
                <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-71">
                  <option data-id="element-72">DNI</option>
                  <option data-id="element-73">CE</option>
                  <option data-id="element-74">Pasaporte</option>
                </select>
              </div>
              <div data-id="element-75">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-76">
                  Número de Identificación
                </label>
                <input type="text" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-77" />
              </div>
            </div>
            <div data-id="element-78">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-79">
                Nombres y Apellidos
              </label>
              <input type="text" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-80" />
            </div>
            <div data-id="element-81">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-82">
                Correo Electrónico
              </label>
              <input type="email" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-83" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-84">
              <div data-id="element-85">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-86">
                  Rol
                </label>
                <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-87">
                  <option data-id="element-88">Administrador</option>
                  <option data-id="element-89">Supervisor</option>
                  <option data-id="element-90">Gestor</option>
                  <option data-id="element-91">Brigada</option>
                </select>
              </div>
              <div data-id="element-92">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-93">
                  Aliado
                </label>
                <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-94">
                  <option data-id="element-95">Aliado A</option>
                  <option data-id="element-96">Aliado B</option>
                  <option data-id="element-97">Aliado C</option>
                </select>
              </div>
            </div>
            <div data-id="element-98">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-99">
                Estado
              </label>
              <Toggle data-id="element-100" />
            </div>
          </div>
        </div>
        <div className="border-t p-6 flex justify-end gap-4" data-id="element-101">
          <button onClick={onClose} className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 text-base" data-id="element-102">
            Cancelar
          </button>
          <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-base" data-id="element-103">
            {user ? 'Guardar Cambios' : 'Crear Usuario'}
          </button>
        </div>
      </div>
    </div>;
};